import { findMessage } from '@bimser/components';
import { removeAuth } from './removeAuth';
import { ServiceList } from '../services/serviceList';
import HTTPRequest from '../services/HTTPRequest';
import { MessageBoxButtons } from '../components/ModalManager/enums';
import MessageBox from '../utilities/messageBoxManager';

const getServicesConfig = () => {
	return (<any>window).serviceConfig.services;
};

export const onRefreshToken = () => {
	return new Promise(resolve => {
		ServiceList.login.Login.Refresh.callPromise()
			.then(resolve)
			.catch(e => {
				const intMsg = e.internalMessage;
				MessageBox.error({
					errorCode: 'Code : ' + e.code,
					content: findMessage.get('103028'),
					buttons: MessageBoxButtons.OK,
					showErrorDetail: true,
					errorDetail: intMsg.message
				}).then(() => removeAuth(false));
			});
	});
};

export const initalizeServices = () => {
	HTTPRequest.createInstances(getServicesConfig());
};
